import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import Raven from 'raven-js';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { DocumentsIcon } from 'foundations-assets/icons/components/DocumentsIcon';
import { InsertVideoIcon } from 'foundations-assets/icons/components/InsertVideoIcon';
import { InvoiceIcon } from 'foundations-assets/icons/components/InvoiceIcon';
import { LessonIcon } from 'foundations-assets/icons/components/LessonIcon';
import { LockedIcon } from 'foundations-assets/icons/components/LockedIcon';
import { MeetingsIcon } from 'foundations-assets/icons/components/MeetingsIcon';
import { PaymentSubscriptionsIcon } from 'foundations-assets/icons/components/PaymentSubscriptionsIcon';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { SalesTemplatesIcon } from 'foundations-assets/icons/components/SalesTemplatesIcon';
import { SignatureIcon } from 'foundations-assets/icons/components/SignatureIcon';
import { TextSnippetIcon } from 'foundations-assets/icons/components/TextSnippetIcon';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getTypeText = type => {
  switch (type) {
    case 'MEETINGS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.meetings"
      });
    case 'KNOWLEDGE_ARTICLE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.knowledgeArticle"
      });
    case 'PAYMENT_LINK':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.paymentLink"
      });
    case 'INVOICES':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.invoices"
      });
    case 'VIDEO_INSERTION':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.video"
      });
    case 'SNIPPETS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.snippets"
      });
    case 'TEMPLATES':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.templates"
      });
    case 'DOCUMENTS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.documents"
      });
    case 'QUOTES':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.quotes"
      });
    case 'SIGNATURE':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.signature"
      });
    default:
      Raven.captureMessage('NO_TYPE_TEXT');
      return '';
  }
};
const getTypeIcon = type => {
  switch (type) {
    case 'MEETINGS':
      return MeetingsIcon;
    case 'KNOWLEDGE_ARTICLE':
    case 'QUOTES':
      return LessonIcon;
    case 'PAYMENT_LINK':
      return PaymentSubscriptionsIcon;
    case 'INVOICES':
      return InvoiceIcon;
    case 'VIDEO_INSERTION':
      return InsertVideoIcon;
    case 'SNIPPETS':
      return TextSnippetIcon;
    case 'TEMPLATES':
      return SalesTemplatesIcon;
    case 'DOCUMENTS':
      return DocumentsIcon;
    case 'SIGNATURE':
      return SignatureIcon;
    default:
      Raven.captureMessage('NO_TYPE_ICON');
      return LessonIcon;
  }
};
const getDisabledText = (editorConfig, type) => {
  switch (type) {
    case 'MEETINGS':
      return undefined;
    case 'KNOWLEDGE_ARTICLE':
      return undefined;
    case 'PAYMENT_LINK':
      return undefined;
    case 'INVOICES':
      return undefined;
    case 'VIDEO_INSERTION':
      return undefined;
    case 'SNIPPETS':
    case 'SIGNATURE':
      return undefined;
    case 'TEMPLATES':
      return !editorConfig[type].contactEmail ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.disabledTooltipMessage"
      }) : undefined;
    case 'DOCUMENTS':
      {
        var _requireContactEmail;
        const requireContactEmail = (_requireContactEmail = editorConfig[type].requireContactEmail) !== null && _requireContactEmail !== void 0 ? _requireContactEmail : true;
        const contactEmail = editorConfig[type].contactEmail;
        return requireContactEmail && !contactEmail ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.insertMenu.disabledTooltipMessage"
        }) : undefined;
      }
    case 'QUOTES':
      return !editorConfig[type].contactVid ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.insertMenu.disabledTooltipMessage"
      }) : undefined;
    default:
      Raven.captureMessage('NO_DISABLED_TEXT');
      return undefined;
  }
};
function InsertMenuTypeButton({
  type,
  editorConfig,
  onSelectMediaType
}) {
  const config = editorConfig[type];
  if (!config) {
    return null;
  }
  const disabledText = getDisabledText(editorConfig, type);
  const disabled = Boolean(disabledText);
  const Icon = getTypeIcon(type);
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !disabled,
    title: disabledText,
    children: /*#__PURE__*/_jsx(Button
    // className="p-x-4 display-flex align-center justify-between"
    , {
      disabled: disabled,
      onClick: () => onSelectMediaType(type),
      "data-test-id": `insert-menu-${type}`,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(IconHolder, {
          marginInlineEnd: "300",
          icon: Icon,
          color: "icon-core-subtle"
        }), getTypeText(type), 'showNewTag' in config && config.showNewTag && /*#__PURE__*/_jsx(Badge, {
          use: "new",
          marginInlineStart: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'hubspot-prosemirror.insertMenu.newTag'
          })
        }), /*#__PURE__*/_jsx(IconHolder, {
          icon: RightIcon
        })]
      })
    })
  });
}
export const InsertMenuUpgradeButton = ({
  type,
  upgradeKey
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeKey);
  const Icon = getTypeIcon(type);
  return /*#__PURE__*/_jsxs(Button, {
    onClick: openUpgradeModal,
    use: "link",
    paddingInline: "400",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      marginInlineEnd: "300",
      icon: Icon,
      color: "icon-core-subtle"
    }), getTypeText(type), /*#__PURE__*/_jsx(IconHolder, {
      marginInlineEnd: "300",
      icon: LockedIcon,
      color: "icon-core-subtle",
      marginInlineStart: "200",
      onClick: openUpgradeModal
    })]
  });
};
export default InsertMenuTypeButton;